<template>
  <proposal />
</template>

<script>
import proposal from "@/components/proposal/proposal";

export default {
  components: {
    proposal
  }
};
</script>
